// Call function with ID. Function selects all textarea, inputs, and select elements within an ID and returns true if all inputs are valid, else returns false

export function isValidForm(formID) {
  let inputs = document.querySelectorAll(
      `#${formID} textarea, #${formID} select, #${formID} input`
  );
  let validity = true;

  if (inputs.length === 0) {
      return true;
  }

  for (let i = 0; i < inputs.length; i++) {
      if (!inputs[i].checkValidity()) {
          validity = false;
          break;
      }
  }

  return validity;
}